/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetEstimationHistoryByDealTypeWebRequest,
  TGetEstimationHistoryByDealTypeWebModel,
  IMappers,
  TGetEstimationHistoryByDealTypeWebResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IEstimationHistoryResponse1 } from '../../entities/estimation_history/EstimationHistoryResponse1';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetEstimationHistoryByDealTypeWebModel(
  parameters: TGetEstimationHistoryByDealTypeWebRequest,
): TGetEstimationHistoryByDealTypeWebModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v1/get-estimation-history-by-deal-type-web/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetEstimationHistoryByDealTypeWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetEstimationHistoryByDealTypeWebRequest;
}

export async function fetchGetEstimationHistoryByDealTypeWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetEstimationHistoryByDealTypeWebOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetEstimationHistoryByDealTypeWebResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetEstimationHistoryByDealTypeWebModel(parameters),
    config,
  )) as FetchResponse<TGetEstimationHistoryByDealTypeWebResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IEstimationHistoryResponse1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetEstimationHistoryByDealTypeWebResponse>;
}
